export const SectionTabs = {
    RECENT_MEMBER: 'recentMember',
    DEPT: 'dept',
    DEPT_MEMBER: 'deptMember',
    MEMBER: 'member',
    GROUP: 'group',
    GROUP_MEMBER: 'groupMember',
    TEAM: 'team',
    TEAM_MEMBER: 'teamMember',
    OUT: 'out',
    OUT_MEMBER: 'outMember',
    ROLE: 'role',
    ROLE_MEMBER: 'roleMember'
}